// components/ReusableBarChart.js
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import "../../index.css";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Barchart = ({
  labels = [],
  values = [],
  labelName = "البيانات",
  color = "#99B975",
  currency = "ر.س"
}) => {
  const data = {
    labels,
    datasets: [
      {
        label: labelName,
        data: values,
        backgroundColor: color,
        borderRadius: 4,
        barPercentage: 0.9,
        categoryPercentage: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
        external: function (context) {
          let tooltipEl = document.getElementById("chartjs-tooltip");

          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-tooltip";
            tooltipEl.className = "chartjs-tooltip";
            document.body.appendChild(tooltipEl);
          }

          const tooltipModel = context.tooltip;

          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          const { offsetLeft: positionX, offsetTop: positionY } =
            context.chart.canvas;

          if (tooltipModel.body) {
            const bodyLines = tooltipModel.body.map((b) => b.lines);

            tooltipEl.innerHTML = bodyLines
              .map(
                (line) => `
                <div class="tooltip-box">${line+" "+currency}</div>
                <div class="tooltip-arrow"></div>
              `
              )
              .join("currency");
          }

          tooltipEl.style.opacity = 1;
          tooltipEl.style.position = "absolute";
          tooltipEl.style.left =
            positionX + tooltipModel.caretX - tooltipEl.offsetWidth / 2 + "px";

          tooltipEl.style.top =
            positionY +
            tooltipModel.caretY -
            tooltipEl.offsetHeight -
            10 +
            "px";

          tooltipEl.style.pointerEvents = "none";
        },
      },
    },
    scales: {
      y: {
        ticks: {
          callback: (value) => value.toLocaleString("en-EG"),
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default Barchart;
